import { render } from "./MyExam.vue?vue&type=template&id=060a8e06"
import script from "./MyExam.vue?vue&type=script&lang=ts"
export * from "./MyExam.vue?vue&type=script&lang=ts"
script.render = render

export default script